import AxiosInstance from "./AxiosInstance";

export const getAllTravelPartner = async () => {
  try {
    const apiEndpoint = (process.env.REACT_APP_API_BASE_URL || "https://www.aacoreholidaysresort.com/api") + "/travel_partner";
    console.log('Calling API:', apiEndpoint);
    const { data } = await AxiosInstance.get("/travel_partner");
    console.log('API Response:', data);
    
    // Check if response is HTML (indicates server error)
    if (typeof data === 'string' && data.includes('<!doctype html>')) {
      throw new Error('Server returned HTML instead of JSON - API endpoint may be down');
    }
    
    return data;
  } catch (error) {
    console.error("Error fetching travel partners:", error.response?.data || error.message);
    // Return mock data as fallback
    return {
      message: "Fallback data",
      travelPartner: [
        {
          _id: "1",
          company_name: "Sample Airline 1",
          image: "/assets/images/placeholder.jpg"
        },
        {
          _id: "2",
          company_name: "Sample Airline 2", 
          image: "/assets/images/placeholder.jpg"
        },
        {
          _id: "3",
          company_name: "Sample Airline 3", 
          image: "/assets/images/placeholder.jpg"
        },
        {
          _id: "4",
          company_name: "Sample Airline 4", 
          image: "/assets/images/placeholder.jpg"
        }
      ]
    };
  }
};
